module.exports = __webpack_public_path__ + "static/media/adress.348839a4.svg";